const translations = {
    amountApplied: 'Amount Applied',
    rate: 'Rate',
    rateApplied: 'Rate Applied',
    totalProductUsed: 'Total Product Used',
    units: 'Units'
};

export default translations;
